import { useRouter } from "../router";
import { AdvisoryHome } from "./advisory/AdvisoryHome";
import { NewAdvice } from "./advisory/NewAdvice";
import { Workbench } from "./advisory/Workbench";

export const ADVISORY_PATH = "/app/advisory";

// The "Advisory" area (M14): Andersen's own advisor workbench on the QP API.
//   /app/advisory          → the advice desk (sessions table)
//   /app/advisory/new      → start a new advice
//   /app/advisory/{id}     → the three-column workbench for one advice
// The {id} form is also the flow instance's internalRedirectUrl, so QP can
// send the advisor straight back. See docs/advisor-workbench.md §4 and §6.
export function Advisory() {
  const { pathname } = useRouter();
  const rest = pathname.slice(ADVISORY_PATH.length).replace(/^\/+|\/+$/g, "");

  if (rest === "new") return <NewAdvice />;
  if (/^\d+$/.test(rest)) {
    const id = Number(rest);
    return <Workbench key={id} sessionId={id} />;
  }
  return <AdvisoryHome />;
}
